import { render } from "./SidebarLink.vue?vue&type=template&id=62f945f6"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SidebarPlugin/SidebarLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f945f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f945f6', __exports__)) {
    api.reload('62f945f6', __exports__)
  }
  
  module.hot.accept("./SidebarLink.vue?vue&type=template&id=62f945f6", () => {
    api.rerender('62f945f6', render)
  })

}


export default __exports__